import Component from '../../js/_Component';
import '../../js/_ResizeObserver';

const CNAME = 'c-block-anchor-subheader';

export default class BlockAnchorSubheader extends Component {

	private desktopMenu: HTMLElement;
	private mobileMenu: HTMLElement;
	private mobileSelect: HTMLSelectElement;

	private queued = false;

	constructor(element: HTMLElement) {
		super(element);

		this.desktopMenu = this.element.querySelector(`.${CNAME}--desktop-menu`);
		this.mobileMenu = this.element.querySelector(`.${CNAME}--mobile-menu`);
		this.mobileSelect = this.element.querySelector(`.${CNAME}--select`);

		let headings = document.querySelectorAll('.site--main h2, .site--main .h2') as NodeListOf<HTMLHeadingElement>;
		let createdHeadings = [];

		headings.forEach( item => {
			let button = document.createElement('button') as HTMLElement;
			let selectOption = document.createElement('option') as HTMLElement;
			let itemHTML = item as HTMLElement;

			if (!item.id) {
				item.id = item.textContent
					.replace(/[^A-Za-z0-9]+/g, '-') // Replace any consecutive non-textual characters with a dash.
					.replace(/^-*(.*?)-*$/, '$1') // Trim dashes from beginning and end.
					.toLowerCase();
			}


			if( itemHTML.classList.contains('h2-promos') ){
				return;
			}

			// Anchors have been swapped out for buttons because we are no-longer using native anchor behavior
			button.addEventListener('click', () => this.goToElement(item));
			button.classList.add(`${CNAME}--item`);
			button.setAttribute("data-href",item.id);
			button.textContent = item.textContent;

			this.mobileSelect.addEventListener('change', () => this.goToSelectElement());
			selectOption.setAttribute("value",item.id);
			selectOption.setAttribute("data-href",item.id);
			selectOption.textContent = item.textContent;

			//create heading
			if(createdHeadings.indexOf(item.id) < 0){
				createdHeadings.push(item.id);
				this.desktopMenu.appendChild(button);
				this.mobileSelect.appendChild(selectOption);
			}
		});

		if (createdHeadings.length <= 1) {
			this.element.style.setProperty('display', 'none');
			return; // Exit
		}


		let observer = new ResizeObserver(() => this.updateMenuSize());

		observer.observe(this.desktopMenu);
		this.updateMenuSize();

		window.addEventListener('scroll', () => this.queuePositionUpdate());
		this.queuePositionUpdate();

		// Check for anchor in URL, if so scroll to element.
		// Hash always returns a # with the anchor, if present.
		// include check for new search term highlighting
		if (window.location.hash.length > 1 && !/^#s\[\]=.+$/.test(window.location.hash) ) {
			let anchorHash = window.location.hash.replace("#", "");
			let isnum = /^\d+$/.test(anchorHash);
			if (isnum) {
				let anchorEl = document.getElementById(anchorHash) as HTMLElement;
			}else{
				let anchorEl = document.querySelector(window.location.hash) as HTMLElement;
			}

			if(typeof(anchorEl) !== 'undefined'){
				// Playing god.
				// There is sort of race condition here where the browser could try to go to a real anchor if it exists.
				setTimeout(() => {
					this.goToElement(anchorEl);
					this.updateMenuSize();
				},500);
			}

		}

	}

	updateMenuSize() {
		// Check against 48rem, or 768px
		// This is specified by the md-12/md-0 in the template.
		if ((document.querySelector('body').clientWidth / 16) < 48) {
			this.element.style.setProperty('height', `${this.mobileMenu.clientHeight}px`);
		} else {
			this.element.style.setProperty('height', `${this.desktopMenu.clientHeight}px`);
		}
	}

	queuePositionUpdate() {
		if (!this.queued) {
			this.queued = true;
			requestAnimationFrame(() => {
				this.queued = false;
				if (this.element.getBoundingClientRect().top <= 0) {
					this.element.classList.add('m-fixed');
				} else {
					this.element.classList.remove('m-fixed');
				}
			});
		}
	}

	goToElement(el: HTMLElement){

		// Update URL to reflect the new position
		if(el.id.length > 1) {
			history.pushState('','',`#${el.id}`); // Use a push state not an update to the window.location hash
		}

		// Use the closest module instead of the direct element, if one exists.
		el = el.closest('.module') || el;

		// Find the nearest element with an offset (if the current element doesn't have an offset).
		while (el && !el.offsetTop) {
			el = el.parentElement;
		}

		// Update the scroll offset to the found element.
		if (el) {
			console.log( el );

			let scrollOffset = (window.scrollY || document.documentElement.scrollTop) + el.getBoundingClientRect().top - this.element.getBoundingClientRect().height;
			window.scrollTo({
				top: scrollOffset,
				behavior: 'smooth',
			});
		}
	}

	goToSelectElement() {
		let option = this.mobileSelect.options[this.mobileSelect.selectedIndex].value;

		let val = '1234567890'
		let isnum = /^\d+$/.test(option);
		if (isnum) {
			let el = document.getElementById(option) as HTMLElement;
			console.log('number');
		}else{
			let el = document.querySelector(`#${option}`) as HTMLElement;
		}

		this.goToElement(el);
	}

}

Component.register(BlockAnchorSubheader, 'BlockAnchorSubheader');
